import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import CampaignGrid from "@/components/landing/CampaignGrid";
import LeadForm from "@/components/landing/LeadForm";
import Process from "@/components/landing/Process";
import TrustSection from "@/components/landing/TrustSection";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import { scrollToForm } from "@/components/landing/Shared";
import { API_BASE } from "@/constants/form";

export default function LandingPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    axios
      .get(`${API_BASE}/campaigns`)
      .then(({ data }) => setCampaigns(data.campaigns || []))
      .catch(() => setCampaigns([]));
  }, []);

  const handleSelect = (id, opts = {}) => {
    setSelected(id);
    if (!opts.silent) scrollToForm();
  };

  return (
    <main data-testid="landing-page" className="bg-[#FBF9F5] text-[#1A1715]">
      <Navbar />
      <Hero />
      <Marquee items={campaigns.map((c) => c.name)} />
      <CampaignGrid campaigns={campaigns} selected={selected} onSelect={handleSelect} />
      <LeadForm campaigns={campaigns} selected={selected} onSelect={handleSelect} />
      <Process />
      <TrustSection />
      <Faq />
      <Footer />

      <div className="fixed bottom-0 inset-x-0 z-40 sm:hidden border-t border-[#E7E2DA] bg-[#FBF9F5]/95 backdrop-blur-md px-5 py-3">
        <button
          type="button"
          data-testid="mobile-sticky-cta"
          onClick={scrollToForm}
          className="w-full bg-[#C2410C] text-[#FBF9F5] font-sans font-semibold text-sm px-6 py-3.5 rounded-sm transition-colors duration-300 active:bg-[#9A3412]"
        >
          Free Case Review — 2 Minutes
        </button>
      </div>
      <div className="h-16 sm:hidden" aria-hidden="true" />
    </main>
  );
}
